import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/business";
const name = "Business";

export const businessApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    ...globalEndpoints(builder, path, name, []),
  }),
});

export const {
  useGetAllBusinessQuery,
  useGetByIdBusinessQuery,

  useLazyGetAllBusinessQuery,
  useLazyCompanyCheckQuery,

  useCreateBusinessMutation,
  useUpdateBusinessMutation,
  useDeleteBusinessMutation,
} = businessApi;
